import React, { useState, useEffect } from "react";
import { Table, Form, Typography, message, Button } from "antd";
import {
    CloudDownloadOutlined,
  } from "@ant-design/icons";
import { useHistory } from 'react-router-dom';
import * as ProductsApiUtil from '../../../../utils/api/products-api-utils';
import { getDataFromLocalStorage, checkUserAuthFromLocalStorage } from "../../../../utils/local-storage/local-store-utils";
import Constants from '../../../../utils/constants/constants';
import * as Helpers from "../../../../utils/helpers/scripts";
import {
    BarcodeOutlined,
} from "@ant-design/icons";
import PrintBarcode from "./printBarcode";


const ProductsViewNestedTable = (props) => {
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [recordSelected, setRecordSelected] = useState(null);

    const history = useHistory();


    const handleDelete = (record) => {
        history.push({
            pathname: `/products/${record.product_id}/delete`,
            data: record // your data array of objects
        });
    };

    const edit = (record) => {
        history.push({
            pathname: `/products/${record.product_id}/edit`,
            data: record // your data array of objects
        });
    };

    const handleSetUserCount = (record) => {
        let count = window.prompt(
          `No. of barcodes for SKU: ${record.product_sku}`,
          0
        );
        var storeObj = null;
        var symbol = null;
        var readFromLocalStorage = getDataFromLocalStorage(Constants.USER_DETAILS_KEY);
        readFromLocalStorage = readFromLocalStorage.data ? readFromLocalStorage.data : null;
        if (readFromLocalStorage) {
            symbol = readFromLocalStorage.currency.symbol;
            if (checkUserAuthFromLocalStorage(Constants.USER_DETAILS_KEY).authentication) {
                var foundStoreObj = readFromLocalStorage.auth.storeInfo.find(obj => {
                    return obj.store_id === readFromLocalStorage.auth.current_store
                })
                if (foundStoreObj) { storeObj = foundStoreObj; }
            }
            else { storeObj = null; }
        }
        if (count > 0) {
          const barcodeData = {
            ...record,
            symbol: symbol,
            storeObj: storeObj,
            count: count,
          }
          setRecordSelected(barcodeData);
          return barcodeData;
        }
      };
    
      const handlePrintBarcode = (countRes) => {
        if (countRes.count > 0) {
          let previewBarcodeHtml = document.getElementById("printBarcode");
          if (!previewBarcodeHtml) {
            return;
          }
          previewBarcodeHtml = document.getElementById("printBarcode").innerHTML;
          let doc =
          `<html><head><title></title><link rel="stylesheet" type="text/css" href="/printBarcodeStyle.css" /><style type="text/css">
          .printBarcode-file {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            margin: 0px 20px;
          }
          .w-100 {
            width: 100%;
          }
          .topleft {
            display: inline-block; 
            font-size: 10px;    
          }
          .topright {
            display: inline-block;   
            float: right; 
            font-size: 10px;    
          } 
          .center {
            text-align: center;
            width: 100%;
            font-size: 10px;    
          }
          .text-elipse {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 10px;    
            width: 50%;
          }
       </style>
          </head><body onload="window.print(); setTimeout(window.close, 0);" >` +
            previewBarcodeHtml +
            "</body></html>";
          /* NEW TAB OPEN PRINT */
          let popupWin = window.open(
            "",
            "_blank",
            "toolbar=no,scrollbars=yes,resizable=yes,top=100,left=400,width=500,height=500"
          );
          if (popupWin) {
            popupWin.document.open();
            //window.print(); window.close(); //'width: 80%, height=80%'
            popupWin.document.write(doc);
            popupWin.document.close(closeFunction()); //vvimp for autoprint
          }
        }
      };
      const closeFunction = () => {
        setRecordSelected(null);
      }

    const barcodeGenerator = async (record) => {
        const countRes = await handleSetUserCount(record);
        if (countRes) {
            await handlePrintBarcode(countRes);
        }
    }

    const fetchProductsVariantsData = async (productUniqueId) => { 

        document.getElementById('app-loader-container').style.display = "block";
        const productsVariantsResponse = await ProductsApiUtil.viewVariants(productUniqueId);
        console.log('productsVariantsResponse:', productsVariantsResponse);
        if (productsVariantsResponse.hasError) {
            console.log('Cant fetch product Variants -> ', productsVariantsResponse.errorMessage);
            setLoading(false);
            document.getElementById('app-loader-container').style.display = "none";
        }
        else {
            console.log('res -> ', productsVariantsResponse);
            //message.success(productsVariantsResponse.message, 3);
            setData(productsVariantsResponse.products);
            setLoading(false);
            document.getElementById('app-loader-container').style.display = "none";
        }
    }


    const toggleFetchProductLookupData = (record) => {
        props.onClickFetchProductLookupData(record);
    };

    useEffect(async () => {
        fetchProductsVariantsData(props.productUniqId);

    }, [props.productUniqId]);  /* imp passing props to re-render */

    var columns = null;


    if (props.originPage && props.originPage === 'lookup' ) {
        columns = [
            {
                title: "product Name",
                dataIndex: "product_name",
                width: "20%",
            },
            {
                title: "SKU",
                dataIndex: "product_sku",
            },
            {
                title: "Varaint 1",
                dataIndex: "product_variant1_value",
                render: (_, record) => {
                    return (
                      <span> {Helpers.var_check_updated(record.product_variant1_value) ?
                         record.product_variant1_value : ""} </span>
                    );
                },
            },
            {
                title: "Varaint 2",
                dataIndex: "product_variant2_value",
                render: (_, record) => {
                    return (
                      <span> {Helpers.var_check_updated(record.product_variant2_value) ?
                         record.product_variant2_value : ""} </span>
                    );
                },
                
            },
            {
                title: "Fetch",
                render: (_, record) => {
                    return (
                        <div className='action-btns'>
                            <Button
                                type='Default'
                                icon={<CloudDownloadOutlined />}
                                onClick={() => toggleFetchProductLookupData(record)}
                                >
                            </Button>
                        </div>
                    );
                }
            },
        ];

    }


    else {
        columns = [
            {
                title: "product Name",
                dataIndex: "product_name",
                width: "20%",
                render: (_, record) => { 
                    return (
                        <div>
                            {record.product_name &&
                                Helpers.var_check_updated(record.product_variant1_value) ? Helpers.var_check_updated(record.product_variant2_value) ? <small>{record.product_name + '/ ' + record.product_variant1_value + '/ ' + record.product_variant2_value}</small>
                                    : <small>{record.product_name + ' / ' + record.product_variant1_value}</small>
                                : Helpers.var_check_updated(record.product_variant2_value) ? <small>{record.product_name + ' / ' + record.product_variant2_value}</small>
                                    : record.product_name
                            }
                        </div>
                    );
                }
            },
            {
                title: "Quantity",
                dataIndex: "product_quantity",
                width: "15%",
            },
            ,
            {
                title: "Sale Price",
                dataIndex: "product_sale_price",
                width: "15%",
            },
            {
                title: "Barcode",
                width: "5%",
                render: (_, record) => {
                    return (
                        <div className='action-btns'>
                            <BarcodeOutlined
                                onClick={() => barcodeGenerator(record)}
                            >
                            </BarcodeOutlined>
                        </div>
                    );
                }
            },
            {
                title: "operation",
                dataIndex: "operation",
                render: (_, record) => {
                    return (
                        <div className='action-btns'>
                            <Typography.Link
                                onClick={() => edit(record)}
                            >
                                Edit
                        </Typography.Link>
                            {data.length >= 1 ? (
                                <Typography.Link
                                    onClick={() => handleDelete(record)}
                                >
                                    delete
                                </Typography.Link>

                            ) : null}
                        </div>
                    );
                },
            },
        ];
    }


    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                dataindex: col.dataIndex,
                title: col.title,
            }),
        };
    });



    return (
        <>
        <Table
            size="middle"
            bordered={true}
            columns={mergedColumns}
            dataSource={data}
            pagination={false}
            //loading={loading}
            rowKey="product_id"
        />
      {recordSelected && <PrintBarcode recordSelected={recordSelected} />}

</>
    );
};

export default ProductsViewNestedTable;